import { useCallback } from 'react';
import { useGetRechargesByContractQuery } from '../services/benefitApi';
export function useHasRecharges(options = {}) {
    const { contractId, enabled = true } = options;
    const { data: rechargesData, isLoading, error: queryError, refetch, } = useGetRechargesByContractQuery({
        contractId: contractId,
        limit: 1,
        offset: 0,
    }, {
        skip: !enabled || !contractId,
        refetchOnMountOrArgChange: true,
    });
    const hasRecharges = rechargesData ? rechargesData.total > 0 : null;
    const getErrorMessage = (queryError) => {
        if (!queryError)
            return null;
        return typeof queryError === 'string' ? queryError : 'Failed to check recharges';
    };
    const error = getErrorMessage(queryError);
    const checkHasRecharges = useCallback(async () => {
        if (!contractId) {
            throw new Error('Contract ID is required');
        }
        try {
            const result = await refetch();
            if ('error' in result) {
                throw new Error('Failed to fetch recharges');
            }
            return (result.data?.total ?? 0) > 0;
        }
        catch (err) {
            throw err instanceof Error ? err : new Error('Failed to check recharges');
        }
    }, [contractId, refetch]);
    return {
        hasRecharges,
        isLoading,
        error,
        refetch,
        checkHasRecharges,
    };
}
